import { AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router} from "@angular/router";
import { DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";
import { EstudioService} from "../../estudio/estudio.service";
import { CustomAlertService} from "../../../_components/custom-alert/custom-alert.service";
import { Title} from "@angular/platform-browser";
import * as moment from 'moment';


@Component({
    selector: 'citacion-materia-curso',
    standalone: false,
    templateUrl: 'citacion-materia-curso.component.html',
    styleUrls: [
        'citacion-materia-curso.component.scss',
        '../../estudio/materias-familia/materia-unidades/materia-unidades.component.scss']
})

export class CitacionMateriaCursoComponent implements OnInit, AfterViewInit {
    dataReady = true;
    rawData: any;

    mesesDisponibles = [
        {id: 8, label: 'Agosto', shortLabel: 'Ago'},
        {id: 9, label: 'Septiembre', shortLabel: 'Sep'},
        {id: 10, label: 'Octubre', shortLabel: 'Oct'},
        {id: 11, label: 'Noviembre', shortLabel: 'Nov'},
        {id: 12, label: 'Diciembre', shortLabel: 'Dic'},
        {id: 1, label: 'Enero', shortLabel: 'Ene'},
        {id: 2, label: 'Febrero', shortLabel: 'Feb'},
        {id: 3, label: 'Marzo', shortLabel: 'Mar'},
        {id: 4, label: 'Abril', shortLabel: 'Abr'},
        {id: 5, label: 'Mayo', shortLabel: 'May'},
        {id: 6, label: 'Junio', shortLabel: 'Jun'},
    ];
    mesSeleccionado: number;

    dataSource: MatTableDataSource<any>;
    displayedColumns = ['Alumno', 'Franja'];
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private snackBar: MatSnackBar,
                private dynamicBarService: DynamicBarService,
                private estudioService: EstudioService,
                private customAlertService: CustomAlertService,
                private titleService: Title) {
    }

    ngOnInit() {
        let franjasData = [];
        this.route.data.subscribe((
            data: {
                nivelaciones: any
            }
        ) => {
            this.rawData = data.nivelaciones;
        });
        this.rawData.fechas.map(fecha => {
            if (this.displayedColumns.indexOf(fecha.fecha) == -1) {
                this.displayedColumns.push(fecha.fecha);
            }
        });


        this.rawData.alumnos.map(alumno => {
            alumno.franjas.map((franja, i) => {
                franja['alumno'] = alumno.alumno;
                franja['showName'] = i == 0;

                franjasData.push(franja);
            });
        });

        this.mesSeleccionado = +this.route.snapshot.paramMap.get('idMes');

        this.dataSource = new MatTableDataSource<any>(franjasData);

        this.titleService.setTitle(`Nivelaciones ${this.rawData.materia.nombreCompleto} - MiGLM`);

        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngAfterViewInit() {
        this.dataSource.sortingDataAccessor = (item, property) => {
            if (property === 'Alumno') {
              return item.alumno.apellidosNombres;
            } else {
              return item[property];
            }
        }
        this.dataSource.sort = this.sort;
        this.dynamicBarService.setBarra('nivelaciones-citacion-mcp-barra', {curso: this.rawData.materia.nombreCompleto});
    }

    cambiarCitacion(evt, fecha, alumnoID, horaID) {
        const modelo = Object.assign({}, fecha.value);


        modelo['materiaCursoPeriodoID'] = this.rawData.materiaID;
        modelo['alumnoID'] = alumnoID;
        modelo['hora'] = horaID;
        modelo.citado = evt.checked;

        this.estudioService.setEstadoCitacionNivelacion(modelo).subscribe(res => {
            this.snackBar.open(`Citación ${modelo.citado ? 'realizada' : 'eliminada'} correctamente.`, null, {duration: 2500});
            fecha.value.id = res['id'];
        }, err => {
            fecha.citado = !evt.checked;
            evt.source._checked = !evt.checked;
            this.customAlertService.setCustomMessage({
                tipo: 'error',
                texto: `No ha sido posible realizar la acción. <br> ${err.error} Código de error: ${err.statusText}`
            });
        });
    }

    cambiarMes(idMes) {
        this.router.navigateByUrl(`/nivelaciones/materia/${this.rawData.materiaID}/mes/${idMes}`, {skipLocationChange: false});
    }

    timer;

    setAsistencia(estado, elemento, idFecha) {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        const fechaInd = elemento.fechas.findIndex(fecha => fecha.fecha == idFecha),
            modelo = Object.assign({}, elemento.fechas[fechaInd]);

        // modelo.ausente = false;
        // modelo.retardo = false;
        elemento.fechas[fechaInd].ausente = false;
        elemento.fechas[fechaInd].retardo = false;
        elemento.fechas[fechaInd].presente = false;
        elemento.fechas[fechaInd].noReportaAsistencia = false;

        elemento.fechas[fechaInd][estado] = true;

        this.timer = setTimeout(() => {
            this.estudioService.setEstadoAsistenciaNivelacion(elemento.fechas[fechaInd]).subscribe(res => {
                this.snackBar.open(`La asistencia del alumno se actualizó correctamente.`, null, {duration: 2500});
            }, err => {
                this.customAlertService.setCustomMessage({
                    tipo: 'error',
                    texto: `No ha sido posible actualizar la asistencia. <br> ${err.error} Código de error: ${err.statusText}`
                });
            });
        }, 500);
    }

    isFecha(fecha) {
        const fechaAnio = new Date().getFullYear(),
            fechaRegistro = moment(new Date(`${fechaAnio}/${this.mesSeleccionado}/${fecha.split(' ')[1]}`));

        return moment().diff(fechaRegistro, 'days') > 0;
    }

    asistenciaMasiva(fecha){
        console.log(this.dataSource['_data']._value.filter(el => el.fechas.filter(fechaDS =>  fechaDS.citado == true && fechaDS.fecha == fecha)));
    }
}
